var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass: "border",
      attrs: {
        title: "Add a field",
        "active-class": "btn-primary",
        "active-value": _setup.activeEditId === 0,
      },
      nativeOn: {
        click: function ($event) {
          return _setup.doShowAddFieldForm.apply(null, arguments)
        },
      },
    },
    [_c("i", { staticClass: "bi bi-plus-lg" }), _vm._v("\n    Field\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }